import api from './api';

export async function generateSmartBoard(profile) {
  const { data } = await api.post('https://jmew.xyz/aac/api/smart_board.php', {
    action: 'generate',
    ...profile,
  });
  return data;
}

export async function reviseSmartBoard(draftToken, changes) {
  const { data } = await api.post('https://jmew.xyz/aac/api/smart_board.php', {
    action: 'revise',
    draft_token: draftToken,
    changes,
  });
  return data;
}

export async function commitSmartBoard(draftToken) {
  const { data } = await api.post('https://jmew.xyz/aac/api/smart_board.php', {
    action: 'commit',
    draft_token: draftToken,
  });
  return data;
}
